import type { Theme } from "../..";
import type { UseThemeProps } from "./types";

/**
 * `useTheme()`
 *
 * This hook can be used to get a specific theme, given its id.
 * If theme id is not specified, it will return all themes.
 */
function useTheme(
	themeFile: Theme.GriddoTheme,
	props: UseThemeProps,
): Array<Theme.GlobalTheme | Theme.Theme> | Theme.Theme {
	const themes: Array<Theme.GlobalTheme | Theme.Theme> = [];

	if (props?.global) {
		themes.push(themeFile.global);
	}

	if (props?.theme) {
		const selectedTheme = themeFile.themes.find((t) => t.id === props.theme);
		selectedTheme && themes.push(selectedTheme);
	} else {
		themes.push(...themeFile.themes);
	}

	return themes.length === 1 ? themes[0] : themes;
}

export { useTheme };
